<template>
  <div class="navbar">



    <div class="right-menu">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{ typeName }}<i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="item of userType" :key="item.doctorid" @click.native="handleRoutList(item.doctorid)">{{ item.name }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-avatar>{{ iconName }}</el-avatar>
      <span class="username">{{ username }}</span>
      <span class="rolename">{{ roleName }}</span>
      <a class="logout" @click="logout">退出登录</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { queryDocType, setDocType } from '@/api/user'

export default {
  computed: {
    ...mapGetters([
      'sidebar',
      'name',
      'avatar',
      'device',
      'username',
      'typeName',
      'roleName'
    ])
  },
  data() {
    return {
      userType: [],
      iconName: 'user'
    }
  },
  created() {
    this.iconName = this.username.charAt(this.username.length - 1)
  },
  mounted() {
    this.getDoctorType()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout() {
      this.$store
        .dispatch('user/logingout')
        .then(() => {
          this.$message({
            message: '退出登录成功',
            type: 'success'
          })
          this.$router.push('/')
        })
    },
    getDoctorType() {
      queryDocType().then(res => {
        this.userType = res.list
      })
    },
    handleRoutList(doctorid) {
      const params = {
        doctorid: doctorid
      }
      this.$store.dispatch('user/setDocType', this.qs.stringify(params)).then(() => {
        // 更新本地存储
        window.localStorage.setItem('store', JSON.stringify(this.$store.state))
        this.$router.push({
          path: '/infoList',
          query: {
            doctorid: doctorid
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.logout{
  margin:0 30px;
  font-size:14px;
}
.username{
  margin-right:10px;
}
.navbar {
  height: 60px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.navbar {
    .el-dropdown {
        border-right:2px solid rgba(0, 0, 0, 0.25);
        padding-right:30px;
        margin-right:30px;
        height:20px;
        position:relative;
        top:15px;
        .el-dropdown-link {
            position:relative;
            top:-15px;
        }
    }
    .rolename {
        color:rgba(0,0,0,0.25);
        border:1px solid rgba(0,0,0,0.25);
        font-size:12px;
        padding:2px 5px;
        border-radius:4px;
    }
}

.el-dropdown-menu {
  position:relative;
  top:30px!important;
}

.navbar .right-menu .el-avatar {
  position:relative;
  top:12px;
  right:5px;
  width:35px;
  height:35px;
  line-height:35px;
  background:#3397FD;
}

</style>
